import React, {useState, useEffect, useRef} from "react";

const TeamCard = ({
  title,
  text,
  img,
}: {
  title: string;
  text: string;
  img: string;
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false);
  const [showReadMore, setShowReadMore] = useState<boolean>(false);
  const [currentHeight, setCurrentHeight] = useState<string>("181px");
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isIphone, setIsIphone] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const words = text.trim().split(/\s+/);
    const slicedWords = words.slice(0, 18);
    const result = slicedWords.join(" ");
    setShowReadMore(result.length < text.length);
  }, [text]);

  useEffect(() => {
    window.innerWidth <= 480 ? setIsMobile(false) : setIsMobile(true);
    if (navigator.userAgent.match(/iP(hone|od)/i)) {
      setIsIphone(true);
    }
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      if (isAccordionOpen) {
        setCurrentHeight(`${contentRef.current.scrollHeight}px`);
      } else {
        setCurrentHeight("181px");
      }
    }
  }, [isAccordionOpen]);

  const handleOnClick = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <>
      <div
        className={` ${isMobile ? "flex" : "hidden"} text-valpeacock font-bold text-[25px] p-[1%] sm:w-full flex-row`}>
        <img
          src={img}
          alt="avatar"
          className="w-[140px] h-[210px] mr-[2%] object-cover"
        />
        <div className="flex flex-col">
          <div className="">{title}</div>
          <p className="text-valmidnight text-[14px] font-normal">{text}</p>
        </div>
      </div>

      <div className={` ${isMobile ? "hidden" : ""} w-full`}>
        <div
          ref={contentRef}
          style={{height: currentHeight}}
          className={`transition-all duration-500 ease-in-out relative border-[#00000024] rounded-[16px] border my-6 overflow-hidden p-2`}>
          <img
            src={img}
            alt="avatar"
            className={`${isMobile ? "w-[108px] h-[165px]" : "w-[108px] h-[165px]"} object-cover rounded-[8px] float-left mr-3 relative z-20`}
          />
          <div className="text-[#0F808E] pt-1 text-[22px] w-[95%]">{title}</div>
          <p className="text-valmidnight text-[14px] font-normal w-[95%]">
            {text}
          </p>
          <button
            className={`${showReadMore ? "" : "hidden"} ${
              isAccordionOpen
                ? "w-[95%]"
                : "bg-white absolute bottom-0 right-6 w-full ms-auto z-10"
            } text-end underline text-[#2A424B] text-[16px] pt-1.5 ${
              isIphone ? "h-[41.5px]" : "h-[34.5px]"
            }`}
            onClick={handleOnClick}>
            {isAccordionOpen ? "Read Less" : "Read More"}
          </button>
        </div>
      </div>
    </>
  );
};

export default TeamCard;
